export enum LoginStage {
  emailPassword = 'emailPassword',
  passwordLessSend = 'passwordLessSend',
  passwordLessConfirm = 'passwordLessConfirm',
}

export type AlterAuthFormData = {
  email: string;
  password: string;
};

export const CUSTOM_ERROR_MESSAGES = {
  'user is blocked':
    'This account has been locked. Please contact AlterMe support for further assistance.',
};

export type AlterPasswordlessPhoneFormData = {
  phone: string;
};

export type AlterPasswordlessCodeFormData = {
  otp: string;
};
